import { DropzoneHandler } from '@open-dxp/js-formbuilder';
import Dropzone from 'dropzone';

const fillHiddenField = (name, value) => {
    const field = document.querySelector(`[name$="[${name}]"]`);
    if (!field) return;

    field.value = value;

    const wrapper = field.closest('.formbuilder-row, .form-group');
    if (wrapper) {
        wrapper.style.display = 'none';
    }
};

fillHiddenField('stelle', document.title.trim());
fillHiddenField('link_zur_stelle', window.location.origin + window.location.pathname);

const formEls = document.querySelectorAll('.formbuilder');

formEls.forEach((formEl) => {
    formEl.addEventListener('formbuilder.dynamic_multi_file.dropzone.init', () => {
        formEl.querySelectorAll('.dynamic-multi-file').forEach((fieldEl) => {
            const dzEl = fieldEl.querySelector('.dropzone-container');
            if (!dzEl || !dzEl.dropzone) return;

            const dz = dzEl.dropzone;
            const engineOptions = JSON.parse(fieldEl.dataset.engineOptions || '{}');
            const maxTotalMb = engineOptions.max_file_size ? parseInt(engineOptions.max_file_size, 10) : null;
            const maxTotalBytes = maxTotalMb ? maxTotalMb * 1024 * 1024 : null;

            const errorEl = document.createElement('p');
            errorEl.className = 'dropzone-error';
            errorEl.hidden = true;
            dzEl.insertAdjacentElement('afterend', errorEl);

            const submitBtn = formEl.querySelector('button[type="submit"]');

            const checkTotalSize = () => {
                const total = dz.files
                    .filter((f) => f.status !== Dropzone.ERROR && f.status !== Dropzone.CANCELED)
                    .reduce((sum, f) => sum + f.size, 0);
                const exceeded = maxTotalBytes && total > maxTotalBytes;
                if (exceeded) {
                    errorEl.textContent = `Die Gesamtgröße aller Dateien darf ${maxTotalMb} MB nicht überschreiten.`;
                }
                errorEl.hidden = !exceeded;
                if (submitBtn) {
                    submitBtn.disabled = exceeded;
                    if (exceeded) {
                        submitBtn.style.setProperty('background-color', '#999', 'important');
                        submitBtn.style.setProperty('border-color', '#999', 'important');
                        submitBtn.style.setProperty('cursor', 'not-allowed', 'important');
                    } else {
                        submitBtn.style.removeProperty('background-color');
                        submitBtn.style.removeProperty('border-color');
                        submitBtn.style.removeProperty('cursor');
                    }
                }
            };

            if (maxTotalBytes) {
                formEl.addEventListener('submit', (e) => {
                    if (!errorEl.hidden) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }
                }, true);

                dz.on('addedfile', checkTotalSize);
                dz.on('removedfile', checkTotalSize);
                dz.on('error', checkTotalSize);
            }

            const hintParts = [];
            if (dz.options.acceptedFiles) {
                const types = dz.options.acceptedFiles
                    .split(',')
                    .map((e) => e.replace('.', '').toUpperCase())
                    .join(', ');
                hintParts.push(`Erlaubte Dateitypen: ${types}`);
            }
            if (maxTotalMb) {
                hintParts.push(`Max. Gesamtgröße: ${maxTotalMb} MB`);
            }
            if (hintParts.length > 0) {
                const hint = document.createElement('p');
                hint.className = 'dropzone-hint';
                hint.textContent = hintParts.join(' · ');
                errorEl.insertAdjacentElement('afterend', hint);
            }
        });
    });

    formEl.addEventListener('submit', () => {
        const submitBtn = formEl.querySelector('button[type="submit"]');
        if (submitBtn && !submitBtn.disabled) {
            submitBtn.disabled = true;
            const spinner = document.createElement('span');
            spinner.className = 'spinner-border spinner-border-sm me-2';
            spinner.setAttribute('role', 'status');
            submitBtn.prepend(spinner);
        }
    });

    try {
        new DropzoneHandler(formEl);
    } catch (error) {
        console.log(error);
    }
});

const firstError = document.querySelector('.formbuilder .is-invalid');
const successMessage = document.querySelector('.formbuilder .alert-success');
const scrollTarget = firstError || successMessage;
if (scrollTarget) {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    requestAnimationFrame(() => {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
}
